import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { EmergencyStaff } from "../../shared/models/emergency/staff.model";


@Component({
    selector: 'app-emergency-staff',
    templateUrl: './staff.component.html',
    styleUrls: ['./staff.component.scss']
})
export class EmergencyStaffComponent implements OnInit {

    staff: EmergencyStaff[] = new Array<EmergencyStaff>();

    constructor() { }

    ngOnInit() {

       
    }   

}

